module.exports = __webpack_public_path__ + "static/media/46_tn.b81c09fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/46_tn.jpg
// module id = 355
// module chunks = 0